export const DEFAULT_GRID_IMAGE_WIDTH = 184;

export const GRID_IMAGE_HEIGHT = 184;

export const TOTAL_IMAGES_IN_A_PAGE = 12;
